import { Comment } from "./Comment";
import { CommentsBlockInterface } from "../interfaces/comments/CommentsBlockInterface";
import { CommentInterface } from "../interfaces/comments/CommentInterface";

export class CommentsBlock implements CommentsBlockInterface {
    comments: Comment[];
    nextCount: number;
    previousCount: number;

    constructor(data: CommentsBlockInterface) {
        Object.assign(this, data);
        if (this.comments) {
            this.comments = this.comments.map((item: CommentInterface) => new Comment(item));
        }
        else {
            this.comments = [];
        }
    }
}
